import { Link } from "@/lib/router-compat";
import type { SeoLink } from "@/lib/seoInternalLinks";

export default function SeoRelatedLinks({ heading, links }: { heading: string; links: SeoLink[] }) {
  if (links.length === 0) return null;
  return <nav aria-label={heading} className="mt-8 border-t border-border pt-6">
    <h2 className="text-lg font-semibold text-foreground mb-3">{heading}</h2>
    <ul className="space-y-3">
      {links.map(link => <li key={link.href}><Link to={link.href} className="text-primary underline underline-offset-4">{link.label}</Link></li>)}
    </ul>
  </nav>;
}